<template>
  <!-- 视频列表 -->
  <div class="container">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getVideoList"
    >
      <div class="videoBox">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="toVideoDetail(item.VodId)"
        >
          <div class="videoItem">
            <div class="v_top">
              <van-image fit="cover" :src="item.CoverUrl" class="vImg" />
              <img
                src="../../../static/images/index/play.png"
                class="playIcon"
              />
            </div>
            <div class="v_btm overFlowTwo">{{ item.Title }}</div>
          </div>
        </div>
      </div>
    </van-list>

    <div class="noDataBox" v-if="list.length == 0">
      <span class="iconfont icon-kong"></span>
      <div>什么也没有！</div>
    </div>
  </div>
</template>
<script>
import { List, Image } from "vant";
import { videoList } from "@/api/video";
export default {
  name: "videoList",
  components: {
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      error: false,
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      list: [],
    };
  },
  methods: {
    //获取视频列表
    getVideoList() {
      var that = this;
      var data = {
        Keyword: "",
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        MemberId: that.$route.query.mid,
      };
      videoList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //跳转视频详情
    toVideoDetail(id) {
      this.$router.push({
        path: "/videoDetail",
        query: { id: id },
      });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.container {
  box-sizing: border-box;
  height: 100vh;
  .videoBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 15px;
    background: #ffffff;
    .videoItem {
      width: 168px;
      height: 150px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
      border-radius: 3px;
      overflow: hidden;
      margin-bottom: 10px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      -ms-border-radius: 3px;
      -o-border-radius: 3px;
      .v_top {
        width: 100%;
        height: 90px;
        position: relative;
        .vImg {
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 3px 3px 0 0;
          -webkit-border-radius: 3px 3px 0 0;
          -moz-border-radius: 3px 3px 0 0;
          -ms-border-radius: 3px 3px 0 0;
          -o-border-radius: 3px 3px 0 0;
        }
        .playIcon {
          width: 22px;
          height: 22px;
          position: absolute;
          z-index: 2;
          bottom: 6px;
          left: 7px;
        }
      }
      .v_btm {
        color: #333333;
        font-size: 14px;
        padding: 8px 7px 0 7px;
      }
    }
  }
}
</style>

